import { named, optional, withDependencies } from '@wix/thunderbolt-ioc'
import { PageFeatureConfigSymbol, Fetch, PageServicesManagerSymbol } from '@wix/thunderbolt-symbols'
import type { IFetchApi, IPageWillMountHandler, IPageServicesRegistrar } from '@wix/thunderbolt-symbols'
import type { TranslationsServicePageConfig } from './types'
import { name } from './symbols'
import { TranslationsDefinition } from '@wix/viewer-service-translations/definition'

export const translationsServicePageWillMount = withDependencies(
	[named(PageFeatureConfigSymbol, name), Fetch, optional(PageServicesManagerSymbol)],
	(
		{ builderCompTypeToTranslationsUrl, shouldTakeTranslationsFromManifest }: TranslationsServicePageConfig,
		{ envFetch }: IFetchApi,
		servicesManagerGetter?: IPageServicesRegistrar
	): IPageWillMountHandler => {
		const builderCompTypeToTranslations: Record<string, Record<string, string>> = {}
		return {
			name: 'translationsService',
			async pageWillMount(): Promise<void> {
				if (!shouldTakeTranslationsFromManifest) {
					return
				}
				const servicesManager = servicesManagerGetter?.get()
				const isServiceOpen = servicesManager && servicesManager.hasService(TranslationsDefinition)
				if (!isServiceOpen) {
					return
				}
				const fetchPromises = Object.entries(builderCompTypeToTranslationsUrl).map(async ([compType, url]) => {
					try {
						const response = await envFetch(url)
						const translations = await response.json()
						builderCompTypeToTranslations[compType] = translations
					} catch (error) {
						console.error(`Failed to fetch translations for ${compType} from ${url}:`, error)
						builderCompTypeToTranslations[compType] = {}
					}
				})

				await Promise.all(fetchPromises)

				const translationsService = servicesManager.getService(TranslationsDefinition)
				translationsService.onConfigChange({ translations: builderCompTypeToTranslations })
			},
		}
	}
)
